import { render } from "./CustomFileUpload.vue?vue&type=template&id=ad099d88&scoped=true"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js"

import "./CustomFileUpload.vue?vue&type=style&index=0&id=ad099d88&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad099d88"]])

export default __exports__